import { useState } from 'react';
import { ChevronRight } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Collapsed drawer of earlier attempts that didn't pass the quality gates. Kept for
 * reference only — these never reach the final cut, so they must not sit in the
 * main board where they read as real work.
 */
export default function RejectedSection({
  title,
  note,
  count,
  children,
}: {
  title: string;
  /** One line explaining why these exist and where they go. */
  note?: string;
  count: number;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  if (count === 0) return null;

  return (
    <div className="mt-4 border-t border-dashed border-border pt-2.5">
      <button
        onClick={() => setOpen((s) => !s)}
        className="flex items-center gap-2 text-[12.5px] text-muted-foreground transition-colors hover:text-foreground"
      >
        <ChevronRight className={cn('h-3.5 w-3.5 text-primary transition-transform', open && 'rotate-90')} />
        <span className="font-medium">
          {title} ({count})
        </span>
      </button>
      {open && (
        <>
          {note && <p className="mb-2 mt-1.5 text-[11.5px] leading-relaxed text-faint">{note}</p>}
          <div className="mt-2 opacity-75">{children}</div>
        </>
      )}
    </div>
  );
}
